<template>
  <div id="app">
    <section id="wrapper">
      <!--[if lt IE 9]>
            <p class="upgrade-browser">Upps!! You are using an <strong>outdated</strong> browser. Please <a href="http://browsehappy.com/" target="_blank">upgrade your browser</a> to improve your experience.</p>
      <![endif]-->

      <!-- START PRELOADER -->
      <div id="loader-wrapper">
        <div class="sk-three-bounce">
          <div class="sk-child sk-bounce1"></div>
          <div class="sk-child sk-bounce2"></div>
          <div class="sk-child sk-bounce3"></div>
          <div class="loader-text">IX COLOMBIA</div>
        </div>
        <div class="loader-section section-left"></div>
        <div class="loader-section section-right"></div>
      </div>
      <!--/ END PRELOADER -->

      <!-- START @HEADER -->
      <header id="header">
        <nav class="navbar navbar-fixed-top" role="navigation">
          <div class="container-fluid">
            <!-- Brand and toggle get grouped for better mobile display -->
            <div class="navbar-header">
              <button type="button" class="navbar-toggle" data-toggle="dropdown">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
              <ul class="dropdown-menu pull-right" id="header-menu">
                <li class="active">
                  <a href="#welcome" class="page-scroll-header">Welcome</a>
                </li>
                <li>
                  <a href="#overview" class="page-scroll-header">Getting started</a>
                  <ul class="nav">
                    <li>
                      <a href="#overview" class="page-scroll-header">Overview</a>
                    </li>
                    <li>
                      <a href="#versions" class="page-scroll-header">Versions</a>
                    </li>
                    <li>
                      <a href="#special" class="page-scroll-header">Special</a>
                    </li>
                    <li>
                      <a href="#what-new" class="page-scroll-header">
                        What's
                        new
                      </a>
                    </li>
                    <li>
                      <a href="#features" class="page-scroll-header">
                        Main
                        Features
                      </a>
                    </li>
                    <li>
                      <a href="#color-schemes" class="page-scroll-header">
                        Color
                        schemes
                      </a>
                    </li>
                    <li>
                      <a href="#fonts" class="page-scroll-header">Fonts</a>
                    </li>
                    <li>
                      <a href="#sounds" class="page-scroll-header">Sounds</a>
                    </li>
                    <li>
                      <a href="#preloader" class="page-scroll-header">Preloaders</a>
                    </li>
                  </ul>
                </li>
                <li class="active">
                  <a href="#contacto" class="page-scroll-header">Contacto</a>
                </li>
                <li>
                  <a href="#installation-guide" class="page-scroll-header">
                    Installation
                    guide
                  </a>
                </li>
                <li>
                  <a href="#compass-support" class="page-scroll-header">
                    CSS
                    Preprocessor
                  </a>
                  <ul class="nav">
                    <li>
                      <a href="#compass-support" class="page-scroll-header">
                        Compass
                        support
                      </a>
                    </li>
                    <li>
                      <a href="#sass-support" class="page-scroll-header">
                        SASS
                        support
                      </a>
                    </li>
                    <li>
                      <a href="#less-support" class="page-scroll-header">
                        LESS
                        support
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="#retina-support" class="page-scroll-header">Additional</a>
                  <ul class="nav">
                    <li>
                      <a href="#retina-support" class="page-scroll-header">
                        Retina
                        support
                      </a>
                    </li>
                    <li>
                      <a href="#bower-support" class="page-scroll-header">
                        Bower
                        support
                      </a>
                    </li>
                    <li>
                      <a href="#ui-components" class="page-scroll-header">
                        UI
                        Components
                      </a>
                    </li>
                    <li>
                      <a href="#widgets" class="page-scroll-header">Widgets</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="#plugins" class="page-scroll-header">
                    Third party
                    credit
                  </a>
                  <ul class="nav">
                    <li>
                      <a href="#plugins" class="page-scroll-header">Plugins</a>
                    </li>
                    <li>
                      <a href="#credit" class="page-scroll-header">Credit</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="#change-log" class="page-scroll-header">Change log</a>
                </li>
                <li>
                  <a href="#quick-search" class="page-scroll-header">
                    Quick
                    search
                  </a>
                </li>
                <li>
                  <a href="#thank-you" class="page-scroll-header">Thank you</a>
                </li>
              </ul>
              <a class="navbar-brand page-scroll" href="#welcome">
                IX Colombia,
                SAS
              </a>
            </div>
            <!-- Collect the nav links, forms, and other content for toggling -->
            <div class="collapse navbar-collapse">
              <ul class="nav navbar-nav">
                <li>
                  <a
                    href="http://ixonline.co/"
                    class="navbar-user"
                  >IX Online</a>
                </li>
                <li>
                  <a
                    href="http://www.qrystalos.com/"
                    class="navbar-user"
                  >Atención Médica en Línea</a>
                </li>
                <!-- <li>
                  <a
                    href="http://76.74.150.31:3052/#/auth/"
                    class="navbar-user"
                  >Reuniones y Comités</a>
                </li> -->
                <!-- <li>
                  <a
                    href="http://76.74.150.31:3053/#/login/"
                    class="navbar-user"
                  >Citas Médicas</a>
                </li> -->
              </ul>
                <!-- target="_blank" -->
              <a
                href="http://ixclientes.co/"
                class="btn btn-warning navbar-btn pull-right"
                style="background: #343A40"
              >
                Clientes
                Miembros
                <i class="icon-arrow-right-circle icons"></i>
              </a>
              <!-- <a href="https://wrapbootstrap.com/theme/blankon-fullpack-admin-theme-WB09J8G43?ref=djavaui" target="_blank" class="btn btn-danger navbar-btn pull-right mr-5" style="margin-right: 10px;">Buy</a> -->
            </div>
          </div>
        </nav>
      </header>
      <!-- /#header -->
      <!--/ END HEADER -->

      <!-- START @SIDEBAR LEFT -->
      <aside id="sidebar-left">
        <div class="sidebar-left-header">
          <!-- src="./assets/favicon.ico" -->
          <!-- <img src="./assets/global/img/ix_colombia.png" alt="Information Experts" height="20%" /> -->
          <img src="./assets/global/img/IX COLOMBIA.png" alt="Information Experts" height="20%" />
        </div>
        <div class="sidebar-left-body">
          <ul class="nav">
            <li class="active">
              <a href="#welcome" class="page-scroll">Bienvenido</a>
            </li>
            <li>
              <a href="#overview" class="page-scroll">Familia Krystalos</a>
              <ul class="nav">
                <li>
                  <a href="#overview" class="page-scroll">En Conjunto</a>
                </li>
                <li>
                  <a href="#versions" class="page-scroll">Versiones</a>
                </li>
                <li>
                  <a href="#special" class="page-scroll">Especiales</a>
                </li>
                <li v-if="mostrar_ocultos">
                  <a href="#what-new" class="page-scroll">What's new</a>
                </li>
                <li v-if="mostrar_ocultos">
                  <a href="#features" class="page-scroll">Main Features</a>
                </li>
              </ul>
            </li>

            <li>
              <a href="#contacto" class="page-scroll">Contactenos</a>
            </li>
          </ul>
        </div>
      </aside>
      <!-- /#sidebar-left -->
      <!--/ END SIDEBAR LEFT -->

      <!-- START @PAGE CONTENT -->
      <section id="page-content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <!-- START @WELCOME -->
              <section id="welcome" class="page-section">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title">
                      &ldquo;KRYSTALOS - Nuestro producto
                      estrella&rdquo;
                    </h3>
                  </div>
                  <div class="panel-body">
                    <div class="row">
                      <div class="col-md-4 col-sm-6 col-xs-12">
                        <ul class="list-unstyled">
                          <!-- <li>Pack: Windows & Web</li>
                          <li>
                            Autor:
                            <a href="http://ixcolombia.com/" target="_blank">IX Colombia, SAS</a>
                          </li> -->
                          <li>
                            Contacto:
                            <a
                              href="mailto:gerencia@ixcolombia.com"
                              target="_blank"
                            >gerencia@ixcolombia.com</a>
                          </li>
                          <li>Ubicaci&oacute;n: <span style="font-weight: bold">Calle 9 #7-75 Edif. AKT Of. 201</span></li>
                          <li>Barrio Tranquilandia, <span style="font-weight: bold">Ch&iacute;a</span> - Cundinamarca</li>
                          <li>Tel&eacute;fonos: Oficina +57 (031) 8859660</li>
                          <li><span style="font-weight: bold; color: red">Ventas 3174350789</span> - Whatsapp 3186516614</li>

                          <!-- <li>
                            Follow: <a href="https://twitter.com/djavaui"
                              target="_blank">https://twitter.com/djavaui</a>
                          </li>
                          <li>
                            Like: <a href="https://www.facebook.com/djavaui"
                              target="_blank">https://www.facebook.com/djavaui</a>
                          </li>
                          <li>
                            Our Code: <a href="https://github.com/djavaui"
                              target="_blank">https://github.com/djavaui</a>
                          </li>-->
                          <!-- <li>
                            Contrataciones: Disponible <span class="label
                              label-success label-circle">&nbsp;</span>
                          </li>-->
                        </ul>
                        <span class="label label-success">
                          Publicado el:
                          31/08/2018
                        </span>
                        <span class="label label-primary">
                          Actualizado el:
                          11/07/2020
                        </span>
                      </div>
                      <div class="col-md-6 col-sm-6 col-xs-12">
                        <blockquote>
                          Gracias por interesarte en nosotros. Somos el aliado
                          tecnol&oacute;gico para materializar tus proyectos.
                          Si tienes alguna duda que est&aacute; m&aacute;s
                          all&aacute; del alcance de esta p&aacute;gina, no
                          dudes en enviarnos un correo electr&oacute;nico
                          a
                          <a
                            href="mailto:gerencia@ixcolombia.com"
                            target="_blank"
                          >gerencia@ixcolombia.com</a>.
                          &iexcl;Muchas gracias!
                        </blockquote>
                      </div>
                      <div class="col-sm-2 hidden-sm hidden-xs">
                        <!-- <img
                          src="http://themes.djavaui.com/blankon-fullpack-admin-theme/img/mascot/html.jpg"
                          alt="mascot"
                          class="mascot pull-right"
                        /> -->
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  src="../src/assets/global/img/welcome.jpg"
                  alt="bienvenido"
                  class="img-responsive"
                />
              </section>
              <!--/ END WELCOME -->

              <!-- START @OVERVIEW -->
              <section id="overview" class="page-section">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title">Familia Krystalos</h3>
                  </div>
                  <div class="panel-body">
                    <div class="text-center mb-10">
                      <img
                        src="../src/assets/global/img/versions.png"
                        alt="versions"
                        class="img-responsive margin-auto"
                      />
                    </div>
                    <p>Nuestras plaformas son completamentes integrales, diseñado para instituciones del sector salud, por lo que permiten unificar toda la informaci&oacute;n de los aspectos asistencials, administrativos y contables</p>
                    <h4>IX COLOMBIA SAS, es una Empresa Especializada en el Desarrollo de Soluciones</h4>
                    <p>Somos una empresa Colombiana fundada el 2 de Septiembre del 2.001 cuya actividad económica es el desarrollo de software y soluciones integrales para el mejoramiento de Procesos Productivos, Presupuesto, Administración y Servicios, con 17 años de experiencia en el mercado.</p>
                    <ul>
                      <li>IPS</li>
                      <li>EPS</li>
                      <li>EPS-S</li>
                      <li>Clínicas</li>
                      <li>Hospitales</li>
                      <li>Centros M&eacute;dicos</li>
                    </ul>
                  </div>
                </div>
              </section>
              <!--/ END OVERVIEW -->

              <!-- START @VERSIONS -->
              <section id="versions" class="page-section">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title">Versiones</h3>
                  </div>
                  <div class="panel-body">
                    <div class="row">
                      <div class="col-sm-6 col-md-4">
                        <div class="thumbnail">
                          <img
                            src="../src/assets/global/img/IPS.png"
                            alt="Krystalos IPS"
                            width="130px"
                          />
                          <div class="caption">
                            <h3 class="text-center">Software Asistencial - No Comercial Adaptado</h3>
                            <p
                              class="text-justify"
                            >La creación de KRYSTALOS, se realizó directamente en el servicio asistencial de una clínica, NO es un software comercial adaptado a una entidad hospitalaria. La mayoría de los software's comerciales fracasan tratando de adaptar los procesos asistenciales a los módulos comerciales, no es nuestro caso dado que nuestra solución nació del proceso asistencial extendiéndose a los demás procesos de gestión hospitalaria.</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="thumbnail">
                          <img
                            src="../src/assets/global/img/EPS.png"
                            alt="Krystalos EPS"
                            width="130px"
                          />
                          <div class="caption">
                            <h3 class="text-center">Empresas Promotoras de Salud</h3>
                            <p
                              class="text-justify"
                            >Nuestro software posee un módulo especializado para las actividades de las EPS, administra y gestiona todos los procesos que deben llevar a cabo, incluye toda la normatividad de ley actualizada.</p>
                            <br />
                            <br />
                            <br />
                            <br />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="thumbnail">
                          <img
                            src="../src/assets/global/img/CE.png"
                            alt="Krystalos Consulta Externa"
                            width="130px"
                          />
                          <div class="caption">
                            <h3 class="text-center">Consulta Externa</h3>
                            <p>El área de Consulta Externa es una dependencia de servicios ambulatorios con múltiples especialidades de la medicina, y nuestro software hace todas las tareas para la administración de la misma, desde las citas médicas con notificaciones SMS, hasta la facturación de los servicios con cobro de deducibles y particulares en cajas.</p>
                            <br />
                            <br />
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="mostrar_ocultos">
                      <div class="col-sm-6 col-md-4">
                        <div class="thumbnail">
                          <img
                            src="http://themes.djavaui.com/blankon-fullpack-admin-theme/img/version/laravel-version.png"
                            alt="laravel version"
                          />
                          <div class="caption">
                            <h3 class="text-center">Laravel Framework</h3>
                            <p>
                              Laravel is beatiful php framework. Its offer
                              amazing ORM, painless routing, powerful queue
                              library,
                              and simple authentication give you the tools you
                              need for modern, maintainable PHP. We sweat
                              the small stuff to help you deliver amazing
                              applications.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="thumbnail">
                          <img
                            src="http://themes.djavaui.com/blankon-fullpack-admin-theme/img/version/ajax-version.png"
                            alt="laravel version"
                          />
                          <div class="caption">
                            <h3 class="text-center">AJAX</h3>
                            <p>
                              Ajax or short for asynchronous JavaScript + XML.
                              is a group of interrelated Web development
                              techniques used on the client-side to create
                              asynchronous Web applications. With Ajax, Web
                              applications
                              can send data to, and retrieve data from, a server
                              asynchronously (in the background) without
                              interfering with the display and behavior of the
                              existing page.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="thumbnail">
                          <img
                            src="http://themes.djavaui.com/blankon-fullpack-admin-theme/img/version/php-version.png"
                            alt="php version"
                          />
                          <div class="caption">
                            <h3 class="text-center">PHP</h3>
                            <p>
                              PHP is a server-side scripting language designed
                              for web development but also used as a
                              general-purpose
                              programming language. PHP code can be simply mixed
                              with HTML code, or it can be used in combination
                              with various templating engines and web
                              frameworks.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="mostrar_ocultos">
                      <div class="col-sm-6 col-md-4">
                        <div class="thumbnail">
                          <img
                            src="http://themes.djavaui.com/blankon-fullpack-admin-theme/img/version/codeigniter-version.png"
                            alt="codeigniter version"
                          />
                          <div class="caption">
                            <h3 class="text-center">Codeigniter Framework</h3>
                            <p>
                              CodeIgniter is an open source rapid development
                              web application framework, for use in building
                              dynamic web sites with PHP. CodeIgniter is loosely
                              based on the popular Model-View-Controller
                              development pattern. While view and controller
                              classes are a necessary part of development under
                              CodeIgniter, models are optional.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="thumbnail">
                          <img
                            src="http://themes.djavaui.com/blankon-fullpack-admin-theme/img/version/yeoman-version.png"
                            alt="codeigniter version"
                          />
                          <div class="caption">
                            <h3 class="text-center">Yeoman + GruntJS</h3>
                            <p>
                              Yeoman helps you to kickstart new projects,
                              prescribing best practices and tools to help you
                              stay productive. The Grunt ecosystem is huge and
                              it's growing every day. With literally hundreds
                              of plugins to choose from, you can use Grunt to
                              automate just about anything with a minimum of
                              effort.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="thumbnail">
                          <img
                            src="http://themes.djavaui.com/blankon-fullpack-admin-theme/img/version/material-design-version.png"
                            alt="material design version"
                          />
                          <div class="caption">
                            <h3 class="text-center">Material Design</h3>
                            <p>
                              It is a design language developed by Google.
                              Material Design makes more liberal use of
                              grid-based
                              layouts, responsive animations and transitions,
                              padding, and depth effects such as lighting and
                              shadows. Material has physical surfaces and edges.
                              Seams and shadows provide meaning about what
                              you can touch.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <!--/ END VERSIONS -->

              <!-- START @SPECIAL -->
              <section id="special" class="page-section">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title">Especiales en Krystalos</h3>
                  </div>
                  <div class="panel-body">
                    <div class="row">
                      <div class="col-sm-6 col-md-6">
                        <div class="thumbnail">
                          <img
                            src="../src/assets/global/img/FACTE.png"
                            alt="blankon project management"
                          />
                          <div class="caption">
                            <h3 class="text-center">Facturaci&oacute;n Electrónica Krystalos</h3>
                            <p>Nuestra aplicación emite los documentos electr&oacute;nicos directamente a la DIAN sin intermediarios ni proveedores tecnol&oacute;gicos, "Software Propio", tenemos especialistas contables y administrativos que hacen todo por usted para ser habilitados; también adaptamos nuestro módulo de facturaci&oacute;n electr&oacute;nica a su sistema administrativo si no requiere utilizar el nuestro.</p>
                            <!-- <a href="../../../production/admin-special/project-management/index.html" target="_blank" class="btn btn-success btn-block">DEMO</a> -->
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6" v-if="mostrar_ocultos">
                        <div class="thumbnail">
                          <img
                            src="http://themes.djavaui.com/blankon-fullpack-admin-theme/img/documentation/special/blankon-ecommerce.jpg"
                            alt="blankon e-commerce"
                          />
                          <div class="caption">
                            <h3 class="text-center">E-Commerce System</h3>
                            <p>
                              It is a design speciality for e-commerce system
                              designs, there are many features for support
                              all system e-commerce store. Such as Dashboard
                              design with overview count product, progress chart
                              and recent activity customers and amazing others
                              design do you need!
                            </p>
                            <a
                              href="../../../production/admin-special/ecommerce/index.html"
                              target="_blank"
                              class="btn btn-success btn-block"
                            >DEMO</a>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6" v-if="mostrar_ocultos">
                        <div class="thumbnail">
                          <img
                            src="http://themes.djavaui.com/blankon-fullpack-admin-theme/img/documentation/special/blankon-human-resources.jpg"
                            alt="blankon human resources"
                          />
                          <div class="caption">
                            <h3 class="text-center">Human Resources</h3>
                            <p>
                              It is a design speciality for human resources
                              system designs, there are many features for
                              support
                              all system HR. Such as Dashboard design with
                              overview count employee, progress chart and
                              amazing
                              others design do you need!
                            </p>
                            <a
                              href="../../../production/admin-special/human-resources/index.html"
                              target="_blank"
                              class="btn btn-success btn-block"
                            >DEMO</a>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6" v-if="mostrar_ocultos">
                        <div class="thumbnail">
                          <img
                            src="http://themes.djavaui.com/blankon-fullpack-admin-theme/img/documentation/special/blankon-investor.jpg"
                            alt="blankon investor"
                          />
                          <div class="caption">
                            <h3 class="text-center">Investor</h3>
                            <p>
                              It is a design speciality for Investor dashboard
                              designs, there are many features for support
                              all system investor analyst. Such as Dashboard
                              design with overview investments, comparison total
                              investments and amazing others design do you need!
                            </p>
                            <a
                              href="../../../production/admin-special/investor/index.html"
                              target="_blank"
                              class="btn btn-success btn-block"
                            >DEMO</a>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6" v-if="mostrar_ocultos">
                        <div class="thumbnail">
                          <img
                            src="http://themes.djavaui.com/blankon-fullpack-admin-theme/img/documentation/special/blankon-marketing-campaign.jpg"
                            alt="blankon investor"
                          />
                          <div class="caption">
                            <h3 class="text-center">Marketing Campaign</h3>
                            <p>
                              It is a design speciality for marketing campaign
                              dashboard designs, there are many features
                              for support all system marketing. Such as
                              Dashboard design with overview count target media
                              social,
                              progress chart and widget marketing and amazing
                              others design do you need!
                            </p>
                            <a
                              href="../../../production/admin-special/marketing-campaign/index.html"
                              target="_blank"
                              class="btn btn-success btn-block"
                            >DEMO</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <!--/ END SPECIAL -->

              <!-- START @WHAT'S NEW -->
              <section id="what-new" class="page-section" v-if="mostrar_ocultos">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title">What's New</h3>
                  </div>
                  <div class="panel-body">
                    <p>
                      We will always give you what you need, in the latest
                      version Blankon there are packages that will help you in
                      your awesome
                      project.
                    </p>
                    <br />
                    <p class="text-strong">New Designs</p>
                    <div class="table-responsive">
                      <table class="table table-bordered table-striped table-condensed">
                        <thead>
                          <tr>
                            <th>Page</th>
                            <th>Description</th>
                            <th style="width: 100px" class="text-center">
                              Live
                              preview
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr class="border-success">
                            <td style="min-width: 150px">Blankon Marketing Campaign</td>
                            <td>
                              It is a design speciality for marketing campaign
                              dashboard designs, there are many features for
                              support all system marketing.
                              Such as Dashboard design with overview count
                              target media social, progress chart and widget
                              marketing
                              and amazing others design do you need!
                            </td>
                            <td class="text-center">
                              <a
                                href="../../../production/admin-special/marketing-campaign/index.html"
                                target="_blank"
                                class="btn btn-block btn-primary"
                              >View</a>
                            </td>
                          </tr>
                          <tr class="border-danger">
                            <td style="min-width: 150px">Blankon HTML Static SeedProject</td>
                            <td>
                              HTML or HyperText Markup Language is the
                              standard markup language used to create web
                              pages.
                            </td>
                            <td class="text-center">
                              <a
                                href="../../../production/admin-seed-project/html/dashboard.html"
                                target="_blank"
                                class="btn btn-block btn-primary"
                              >View</a>
                            </td>
                          </tr>
                          <tr class="border-primary">
                            <td style="min-width: 150px">Blankon AngularJS SeedProject</td>
                            <td>
                              AngularJS is an open-source web application
                              framework, maintained by Google and community,
                              that assists with creating single-page
                              applications, which consist of one HTML page
                              with CSS, and JavaScript on the client side.
                            </td>
                            <td class="text-center">
                              <a
                                href="../../../production/admin-seed-project/angularjs/#/dashboard"
                                target="_blank"
                                class="btn btn-block btn-primary"
                              >View</a>
                            </td>
                          </tr>
                          <tr class="border-danger">
                            <td style="min-width: 150px">Blankon AJAX SeedProject</td>
                            <td>
                              Ajax or short for asynchronous JavaScript + XML.
                              is a group of interrelated Web development
                              techniques used on the client-side
                              to create asynchronous Web applications.
                            </td>
                            <td class="text-center">
                              <a
                                href="../../../production/admin-seed-project/ajax/#dashboard"
                                target="_blank"
                                class="btn btn-block btn-primary"
                              >View</a>
                            </td>
                          </tr>
                          <tr class="border-info">
                            <td style="min-width: 150px">Blankon PHP SeedProject</td>
                            <td>
                              PHP is a server-side scripting language designed
                              for web development but also used as a
                              general-purpose programming language.
                            </td>
                            <td class="text-center">
                              <a
                                href="../../../production/admin-seed-project/php/index.php"
                                target="_blank"
                                class="btn btn-block btn-primary"
                              >View</a>
                            </td>
                          </tr>
                          <tr class="border-warning">
                            <td style="min-width: 150px">Blankon Material Design SeedProject</td>
                            <td>
                              It is a design language developed by Google.
                              Material Design makes more liberal use of
                              grid-based layouts, responsive animations
                              and transitions, padding, and depth effects such
                              as lighting and shadows.
                            </td>
                            <td class="text-center">
                              <a
                                href="../../../production/admin-seed-project/material-design/dashboard.html"
                                target="_blank"
                                class="btn btn-block btn-primary"
                              >View</a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </section>
              <!--/ END WHAT'S NEW -->

              <!-- START @FEATURES -->
              <section id="features" class="page-section" v-if="mostrar_ocultos">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title">Main features</h3>
                  </div>
                  <div class="panel-body">
                    <p>
                      There are many features and pages available within
                      Blankon - Fullpack Admin Theme. Check the features
                      below, and I will add
                      more features in future updates.
                    </p>
                    <div class="row">
                      <div class="col-md-6">
                        <ul>
                          <li>Ready Yeoman + GruntJS version</li>
                          <li>Ready Codeigniter version</li>
                          <li>Ready PHP version</li>
                          <li>Ready AJAX version</li>
                          <li>Ready Laravel Framework version</li>
                          <li>Ready Yii2 Framework version</li>
                          <li>Ready AngularJS Framework version</li>
                          <li>Latest Bootstrap v3.3.5</li>
                          <li>Development using LESS</li>
                          <li>Development using SASS + Compass</li>
                          <li>100% Responsive layout</li>
                        </ul>
                      </div>
                      <div class="col-md-6">
                        <ul>
                          <li>50+ Jquery plugins</li>
                          <li>
                            120+ Page files (HTML version &amp; AngularJS
                            version)
                          </li>
                          <li>
                            5 Icon types (Glyphicons, Glyphicons Pro, Font
                            Awesome, Etc)
                          </li>
                          <li>Playing 25 sounds type</li>
                          <li>4 Chart powered</li>
                          <li>
                            27 Colors schemes, 7 sidebar colors, 7 navbar
                            colors
                          </li>
                          <li>5 Widget (overview, social, blog, weather, misc)</li>
                          <li>Summernote WYSWYG</li>
                          <li>Responsive datatable</li>
                          <li>And many more</li>
                          <li>Frontend (Start page)</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <!--/ END FEATURES -->

              <!-- START @CONTACTO -->
              <section id="contacto" class="page-section">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title">Contactenos</h3>
                  </div>
                  <div class="panel-body">
                    <p>Para contactarnos llena el siguiente formulario y nos pondremos en contacto contigo.</p>
                    <div class="row">
                      <div class="col-md-12">
                        <!-- Start input grid -->
                        <div class="panel rounded shadow">
                          <div class="panel-body no-padding">
                            <form action="#">
                              <div class="form-body">
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-md-6">
                                      <input
                                        placeholder="Nombre de mi empresa / Mi nombre"
                                        v-model="nombre"
                                        ref="nombre"
                                        class="form-control"
                                        type="text"
                                        v-on:keypress.enter.prevent="contactar"
                                      />
                                    </div>
                                    <div class="col-md-6">
                                      <input
                                        placeholder="Correo Electrónico"
                                        class="form-control"
                                        type="text"
                                        v-model="correo"
                                        ref="correo"
                                        v-on:keypress.enter.prevent="contactar"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-md-12">
                                      <input
                                        placeholder="Consulta"
                                        class="form-control"
                                        type="text"
                                        v-model="mensaje"
                                        ref="mensaje"
                                        v-on:keypress.enter.prevent="contactar"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <input
                                        placeholder="Teléfono de Contacto"
                                        class="form-control"
                                        type="text"
                                        v-model="telefono"
                                        ref="telefono"
                                        v-on:keypress.enter.prevent="contactar"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- /.form-body -->
                              <div class="form-footer">
                                <div class="pull-right">
                                  <!-- <button class="btn btn-danger mr-5">Cancel</button> -->
                                  <button
                                    class="btn btn-success"
                                    :disabled="cargando"
                                    type="button"
                                    @click="contactar"
                                  >Contactar</button>
                                </div>
                                <div class="clearfix"></div>
                              </div>
                              <!-- /.form-footer -->
                            </form>
                          </div>
                          <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                        <!--/ End input grid -->
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <!--/ END CONTACTO -->
            </div>
          </div>
        </div>
      </section>
      <!--/ END PAGE CONTENT -->
    </section>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      nombre: "",
      mensaje: "",
      correo: "",
      telefono: "",
      cargando: false,
      mostrar_ocultos: false
    };
  },
  methods: {
    contactar() {
      if (this.nombre === "") {
        return this.$refs.nombre.focus();
      }
      if (this.correo === "") {
        return this.$refs.correo.focus();
      }
      if (this.mensaje === "") {
        return this.$refs.mensaje.focus();
      }
      if (this.telefono === "") {
        return this.$refs.telefono.focus();
      }
      // 3174350789
      // alert(this.Mensaje);
      // return;
      var titulo = "Contacto desde ixcolombia.com";
      this.cargando = true;
      this.$http
        .get(
          `https://gentle-reaches-57765.herokuapp.com/note/o.gmcvJbsXhSlkxLczFTnj7fsewzcJSrJb/gerenciaix@ixcolombia.com/${this.Mensaje}/${titulo}`
        )
        .then(response => {
          this.cargando = false;
          alert(
            "Hemos recibido su mensaje, el contactaremos a la brevedad posible"
          );
          // console.log(response);
          this.$http
            .get(
              `https://gentle-reaches-57765.herokuapp.com/sms/o.gmcvJbsXhSlkxLczFTnj7fsewzcJSrJb/ujz7iq3eKcK/ujz7iq3eKcKsjvoe5iEwa4/3168773894/Contacto desde ixcolombia.com >> ${this.Mensaje}`
            )
            .then(response => {
              this.$http
                .get(
                  `https://gentle-reaches-57765.herokuapp.com/sms/o.gmcvJbsXhSlkxLczFTnj7fsewzcJSrJb/ujz7iq3eKcK/ujz7iq3eKcKsjvoe5iEwa4/3186516614/Contacto desde ixcolombia.com >> ${this.Mensaje}`
                )
                .then(response => {
                  this.$http
                    .get(
                      `https://gentle-reaches-57765.herokuapp.com/sms/o.gmcvJbsXhSlkxLczFTnj7fsewzcJSrJb/ujz7iq3eKcK/ujz7iq3eKcKsjvoe5iEwa4/${this.telefono}/Hola, hemos tomado nota de tu solicitud, puedes de igual manera comunicarte con nuestro personal a los siguientes numeros (+57) (3168773894 - 3174350789 - 3186516614)`
                    )
                    .then(response => {
                      this.$http
                        .get(
                          `https://gentle-reaches-57765.herokuapp.com/sms/o.gmcvJbsXhSlkxLczFTnj7fsewzcJSrJb/ujz7iq3eKcK/ujz7iq3eKcKsjvoe5iEwa4/3174350789/Contacto desde ixcolombia.com >> ${this.Mensaje}`
                        )
                        .then(response => {
                          // console.log(response);
                        })
                        .catch(err => {
                          console.log(err);
                        });
                    })
                    .catch(err => {
                      console.log(err);
                    });
                })
                .catch(err => {
                  console.log(err);
                });
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(err => {
          this.cargando = false;

          console.log(err);
        });
    }
  },
  computed: {
    Mensaje() {
      return `(${this.nombre}) ${this.mensaje} - Contactarnos al correo: ${this.correo} o al número: ${this.telefono}`;
    }
  }
};
</script>

<style>
.oculto {
  display: hide;
}
</style>



// WEBPACK FOOTER //
// src/App.vue